import { render } from "./FooterVue.vue?vue&type=template&id=dca8d374&scoped=true"
import script from "./FooterVue.vue?vue&type=script&lang=js"
export * from "./FooterVue.vue?vue&type=script&lang=js"

import "./FooterVue.vue?vue&type=style&index=0&id=dca8d374&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dca8d374"]])

export default __exports__